import React, { useState } from "react";
import { Tooltip } from "react-tooltip";

interface TimePickerProps {
  value: string;
  onChange: (value: string) => void;
}

const TimePicker: React.FC<TimePickerProps> = ({ value, onChange }) => {
  const [hours, minutes, seconds] = value?.split(":");

  const handleTimeChange = (unit: "hours" | "minutes" | "seconds", newValue: string) => {
    const updatedTime = {
      hours: unit === "hours" ? newValue : hours,
      minutes: unit === "minutes" ? newValue : minutes,
      seconds: unit === "seconds" ? newValue : seconds,
    };
    onChange(`${updatedTime.hours}:${updatedTime.minutes}:${updatedTime.seconds}`);
  };

  const timeOptions = (max: number) =>
    Array.from({ length: max + 1 }, (_, i) => i.toString().padStart(2, "0"));

  return (
    <div className="flex items-center space-x-2">
      <div data-tooltip-id="hours-tooltip" data-tooltip-content="Часы">
        <select
          value={hours}
          onChange={(e) => handleTimeChange("hours", e.target.value)}
          className="p-2 border border-gray-300 rounded-md"
        >
          {timeOptions(23).map((h) => (
            <option key={h} value={h}>
              {h}
            </option>
          ))}
        </select>
      </div>
      <span>:</span>
      <div data-tooltip-id="minutes-tooltip" data-tooltip-content="Минуты">
        <select
          value={minutes}
          onChange={(e) => handleTimeChange("minutes", e.target.value)}
          className="p-2 border border-gray-300 rounded-md"
        >
          {timeOptions(59).map((m) => (
            <option key={m} value={m}>
              {m}
            </option>
          ))}
        </select>
      </div>
      <span>:</span>
      <div data-tooltip-id="seconds-tooltip" data-tooltip-content="Секунды">
        <select
          value={seconds}
          onChange={(e) => handleTimeChange("seconds", e.target.value)}
          className="p-2 border border-gray-300 rounded-md"
        >
          {timeOptions(59).map((s) => (
            <option key={s} value={s}>
              {s}
            </option>
          ))}
        </select>
      </div>
      <Tooltip id="hours-tooltip" />
      <Tooltip id="minutes-tooltip" />
      <Tooltip id="seconds-tooltip" />
    </div>
  );
};

export default TimePicker;
